<div class="containerLogin">
  <div style="width: 40%" class="containerLoginImage"></div>
  <div class="d-flex flex-column p-4 align-items-start justify-content-center gap-2 containerLoginForm">
    <img src="../../../assets/logos/seat-cupra-logo-white.svg" alt="Seat Cupra Logo"
      style="margin-left: -25px; margin-top: -16px" />
    <div class="loginTitle">
      <!--<div *ngIf="group.length > 0" style="cursor: pointer" (click)="goBack()">
        <img src="../../../assets/icons/arrow_back_white.svg" alt="icon" width="20px"/>
      </div>-->
      <span style="font-size: 1.5rem">{{ 'login' | i18next }}</span>
    </div>
    <span *ngIf="group.length === 0" class="lead">{{
      'selectYourGroup' | i18next
      }}</span>
    <span *ngIf="group.length > 0" class="lead">{{
      'continueLogin' | i18next
      }}</span>
    <div *ngIf="group.length === 0" class="d-flex flex-column mt-4 gap-4 containerInitialForm">
      <button mat-raised-button (click)="activeDirectory()" class="primaryBtn text-nowrap">
        {{ 'employee' | i18next | uppercase }}
      </button>
      <button mat-raised-button (click)="selectGroup('EXT')" class="primaryBtn text-nowrap">
        {{ 'externalEmployees' | i18next | uppercase }}
      </button>
      <button mat-raised-button (click)="selectGroup('PSS')" class="primaryBtn text-nowrap">
        {{ 'pscs' | i18next | uppercase }}
      </button>
      <button mat-raised-button (click)="selectGroup('EXP')" class="primaryBtn text-nowrap">
        {{ 'expatriates' | i18next | uppercase }}
      </button>
      <button mat-raised-button (click)="selectGroup('EXTERNVO')" class="primaryBtn text-nowrap">
        {{ 'externVO' | i18next | uppercase }}
      </button>
      <!-- CRMSP-7485 - Acceso a MyGarage VO para Empresas externas VO -->
      <button mat-raised-button (click)="selectGroup('COMPANY_VO')" class="primaryBtn text-nowrap">
        EMPRESAS EXT. VO
      </button>
      <!--<button
        mat-raised-button
        (click)="selectGroup('FAMILY')"
        class="primaryBtn secondaryBtn text-nowrap"
      >
        {{ 'relatives' | i18next | uppercase }}
      </button>
      <button
        mat-raised-button
        (click)="selectGroup('OTHERS')"
        class="primaryBtn secondaryBtn text-nowrap"
      >
        {{ 'otherGroups' | i18next | uppercase }}
      </button>-->
    </div>
    <form *ngIf="group.length > 0" [formGroup]="userForm" class="d-flex flex-column mt-4 gap-4 containerForm"
      (ngSubmit)="onSubmit()">
      <mat-card-actions>
        <mat-button-toggle-group class="groupContainer" formControlName="loginType" name="login" aria-label="login"
          (change)="changeGroup($event.value)">
          <mat-button-toggle class="groupBtn" value="EMPLOYEE">{{
            'employee' | i18next | uppercase
            }}</mat-button-toggle>
          <mat-button-toggle class="groupBtn" value="EXT">{{
            'externalEmployees' | i18next | uppercase
            }}</mat-button-toggle>
          <mat-button-toggle class="groupBtn" value="PSS">{{
            'pscs' | i18next | uppercase
            }}</mat-button-toggle>
          <mat-button-toggle class="groupBtn" value="EXP">{{
            'expatriates' | i18next | uppercase
            }}</mat-button-toggle>
          <mat-button-toggle class="groupBtn" value="EXTERNVO">{{
            'externVO' | i18next | uppercase
            }}</mat-button-toggle>
          <!-- CRMSP-7485 - Acceso a MyGarage VO para Empresas externas VO -->
          <mat-button-toggle class="groupBtn" value="COMPANY_VO">
            EMPRESAS EXT. VO
          </mat-button-toggle>
          <!--<mat-button-toggle class="groupBtn" value="FAMILY">{{ 'relatives' | i18next | uppercase }}</mat-button-toggle>
          <mat-button-toggle class="groupBtn" value="OTHERS">{{ 'otherGroups' | i18next | uppercase }}</mat-button-toggle>-->
        </mat-button-toggle-group>
      </mat-card-actions>
      <section class="d-flex flex-column mt-4 containerInputs">
        <!-- CRMSP-7485 - Acceso a MyGarage VO para Empresas externas VO -->
        <mat-form-field *ngIf="!isEmail() && group !== 'EXTERNVO' && group !== 'COMPANY_VO'" class="inputsLogin">
          <mat-label for="nis">{{ 'nis' | i18next }}</mat-label>
          <input matInput type="text" formControlName="nis" minlength="6" maxlength="6" #autofocus />
        </mat-form-field>
        <mat-form-field *ngIf="!isEmail() && (group === 'EXTERNVO' || group === 'COMPANY_VO')" class="inputsLogin">
          <mat-label for="nis">{{ 'nif' | i18next }}</mat-label>
          <input matInput type="text" formControlName="nis" minlength="9" maxlength="9" #autofocus />
        </mat-form-field>
        <!-- end -->
        <mat-form-field *ngIf="isEmail()" class="inputsLogin">
          <mat-label for="nis">{{ 'email' | i18next }}</mat-label>
          <input matInput type="email" formControlName="nis" #autofocus />
        </mat-form-field>
        <mat-form-field class="inputsLogin">
          <mat-label for="password">{{ 'password' | i18next }}</mat-label>
          <input matInput type="password" formControlName="password" />
        </mat-form-field>
        <div class="sectionQuestions mb-4">
          <p>{{ 'forgotPasswordQuestion' | i18next }}</p>
          <p (click)="openDialog()" style="cursor: pointer; text-decoration: underline">
            {{ 'forgotPassword' | i18next }}
          </p>
        </div>
        <div class="sectionQuestions">
          <p>{{ 'createUserText' | i18next }}</p>
          <p style="cursor: pointer; text-decoration: underline" (click)="goToRegister()">
            {{ 'createUserBtn' | i18next }}
          </p>
        </div>
        <app-error-with-guide class="errorMessage" [messageRestore]="restoreErrorMessage"
          [showRestoreGuideLink]="showRestoreGuideLink" [messageLogin]="loginErrorMessage"
          [showGuideLink]="showDownloadGuideLink" [message]="errorMessage">
        </app-error-with-guide>
        <div class="buttonLogin">
          <button class="primaryBtn secondaryBtn" mat-button (click)="onSubmit()" [disabled]="spinner">
            {{ 'login' | i18next | uppercase }}
          </button>
          <div class="spinner-border spinner" role="status" *ngIf="spinner"></div>
        </div>
      </section>
    </form>
  </div>
  <footer class="footer">
    <span style="cursor: pointer" class="text-decoration-none text-white text-uppercase footerLink"
      (click)="openSupportModal()">{{ 'footerHelp' | i18next }}</span><span>|</span>
    <span style="cursor: pointer" class="text-decoration-none text-white text-uppercase footerLink"
      (click)="onFooterClick('legal')">{{ 'footerLegalNote' | i18next }}</span><span>|</span>
    <span style="cursor: pointer" class="text-decoration-none text-white text-uppercase footerLink"
      (click)="onFooterClick('privacy')">{{ 'footerPrivacyPolicy' | i18next }}</span><span>|</span>
    <span style="cursor: pointer" class="text-decoration-none text-white text-uppercase footerLink"
      (click)="onFooterClick('cookies')">{{ 'footerCookiesPolicy' | i18next }}</span>
  </footer>
</div>